<mat-form-field>
  <mat-label>Kunde</mat-label>
  <input matInput [formControl]="searchControl" tabindex="0" autofocus>
</mat-form-field>

<mat-list>
  @for (user of users(); track user.id) {
    <mat-list-item>
      {{ user.mail }}
      <ui-icon-button icon="user-viewfinder" iconStyle="solid" matListItemMeta (clicked)="setUser(user); userSelected.emit(user)"></ui-icon-button>
    </mat-list-item>
  }
</mat-list>
